import { getReqs, setupCreateUpdateClocks } from 'features/firebase-app'
import * as firestore from 'firebase/firestore'
// This import loads the firebase namespace along with all its type information.
import {
  addDoc,
  deleteDoc,
  serverTimestamp,
  updateDoc,
} from 'firebase/firestore'
import Account from './account-model'
import {
  AccountMetaProperties,
  AccountProperties,
} from './account-property-definitions'

export async function load_accounts($args: {
  uid: string
}): Promise<Account[]> {
  let { db } = getReqs()
  let { uid } = $args
  let collection = firestore.collection(db, `accounts`, `${uid}`, 'account')
  let result: Account[] = []
  await firestore
    .getDocs(firestore.query(collection))
    .then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        console.log(doc.id, ' => ', doc.data())
        result.push(convertToaccount(doc))
      })
    })
    .catch((error) => {
      console.log('Error getting documents: ', error)
    })
  return result.filter((x) => x)
}

function convertToaccount(doc: any) {
  let temp: any = {
    id: doc.id,
    ...doc.data(),
  }
  temp = {
    ...temp,
    fire_id: doc.id,
    id: doc.id,
  }
  setupCreateUpdateClocks(temp)

  return temp
}

export async function delete_account(args: {
  uid: string
  id: string
}): Promise<boolean> {
  let { db } = getReqs()
  if (args.uid) {
    let obj = firestore.doc(db, `accounts`, `${args.uid}`, 'account', args.id)
    await deleteDoc(obj)
    return true
  }
  return false
}

export async function store_account(args: Account): Promise<Account> {
  let { db } = getReqs()
  let { owner, fire_id } = args
  if (fire_id) {
    // update
    let account_collection = firestore.doc(
      db,
      `accounts`,
      `${owner}`,
      'account',
      fire_id,
    )
    let temp: any = {
      version: (args.version || 0) + 1,
      owner,
    }
    ;[
      ...Object.values(AccountProperties),
      ...Object.values(AccountMetaProperties),
    ].forEach((prop) => {
      temp[prop] = (args as any)[prop]

      if (temp[prop] === undefined) {
        temp[prop] = null
      }
    })
    await updateDoc(account_collection, {
      ...temp,
      updated: serverTimestamp(),
    })

    return temp
  } else {
    // add
    let collection = firestore.collection(db, `accounts`, `${owner}`, 'account')
    let temp: any = {
      version: (args.version || 0) + 1,
      owner,
    }
    ;[
      ...Object.values(AccountProperties),
      ...Object.values(AccountMetaProperties),
    ].forEach((prop) => {
      temp[prop] = (args as any)[prop]

      if (temp[prop] === undefined) {
        temp[prop] = null
      }
    })
    const docRef = await addDoc(collection, {
      ...temp,
      created: serverTimestamp(),
    })

    console.log('Document written with ID: ', docRef.id)
    temp.id = docRef.id
    temp.fire_id = docRef.id
    return temp
  }
}
